import type { AppConfigurationClient, ConfigurationSetting } from '@azure/app-configuration'

export const getAppConfigClient = async (): Promise<AppConfigurationClient> => {
    const { AppConfigurationClient } = await import('@azure/app-configuration')
    const { DefaultAzureCredential } = await import('@azure/identity')

    const endpoint = process.env.APPCONFIG_ENDPOINT!

    return new AppConfigurationClient(endpoint, new DefaultAzureCredential())
}

export const fetchFromAppConfiguration = async (key: string): Promise<ConfigurationSetting> => {
    const label = process.env.ENVIRONMENT_LABEL || 'prod'
    const client = await getAppConfigClient()

    return await client.getConfigurationSetting({
        key,
        label,
    })
}
